module.exports = __webpack_public_path__ + "img/price-960x640.abc3a41c.jpg";